import styled, { useTheme } from 'styled-components';
import { Checkmark } from 'shared/icons/Checkmark';

import { variableFontRegular } from 'styles/theme/text';

interface ICheckboxRadio {
  'data-qa'?: string;
  checked: boolean;
  children?: React.ReactNode;
  className?: string;
  id?: string;
  label?: string | React.ReactNode;
  labelStyle?: { [key: string]: string | number };
  name: string;
  onChange: (e?: any) => void;
  type: 'radio' | 'checkbox';
  value?: number | string;
  labelOrderReverse?: boolean;
}

export const CheckboxRadio = ({
  'data-qa': dataQa,
  checked,
  children,
  className,
  id,
  label,
  name,
  onChange,
  labelStyle,
  type = 'checkbox',
  value,
  labelOrderReverse = false,
}: ICheckboxRadio) => {
  const theme = useTheme();

  return (
    <CheckboxRadio.Label
      $labelOrderReverse={labelOrderReverse}
      className={className}
      data-qa={dataQa || name}
      htmlFor={typeof label === 'string' ? label : id}
      style={labelStyle}
    >
      {label}
      {children}
      <CheckboxRadio.InputContainer>
        <CheckboxRadio.Input
          type={type}
          id={typeof label === 'string' ? label : id}
          onChange={onChange}
          checked={checked}
          name={name}
          value={value}
        />
        {checked && <CheckboxRadio.Checkmark color={theme.navigation.textColor} />}
        <CheckboxRadio.SelectBox data-qa="select-box" />
      </CheckboxRadio.InputContainer>
    </CheckboxRadio.Label>
  );
};

CheckboxRadio.SelectBox = styled.span`
  border: 1px solid ${({ theme }) => theme.navigation.borderColor};
  width: 16px;
  height: 16px;
`;

CheckboxRadio.Label = styled.label<{ $labelOrderReverse: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
  ${variableFontRegular({ size: '11.5px', height: '16px' })};

  &:last-child {
    margin-bottom: 0;
  }
`;

CheckboxRadio.InputContainer = styled.span`
  display: grid;

  input {
    grid-column: 1;
    grid-row: 1;
  }

  svg {
    grid-column: 1;
    grid-row: 1;
  }

  span {
    grid-column: 1;
    grid-row: 1;
  }
`;

CheckboxRadio.Checkmark = styled(Checkmark)`
  margin: 4px 0 0 3px;
`;

CheckboxRadio.Input = styled.input`
  position: absolute;
  opacity: 0;
  z-index: ${({ theme }) => theme.zIndex.checkboxIcon};
`;
